import React from 'react';
import { Box, Typography } from '@mui/material';
import useRTL from 'src/hooks/useRTL';
import { useCompanyData } from '../../shared/contexts/DataContext';
import { textVariant, textClasses } from '../../shared/config';

const SectionTitle = ({ children, ...props }) => {
  const { data } = useCompanyData();
  const { generalTitleFontSize, generalTitleColor } = data || {};
  const titleFontColor = props.color ? props.color : generalTitleColor ? generalTitleColor : '#000';

  const [, ,fontFamily] = useRTL('',"'Nunito Sans', sans-serif");
  const { contentSection=false } = props || {};

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62'];
  
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62'];
  
  return (
    <Box
      pb={3}
      display="flex"
      alignItems="center"
      color={titleFontColor}
      style={{fontFamily:'inherit'}}
      {...props}
    >
      {!contentSection ?
      <Box
        component="span"
        width="16px"
        height="16px"
        borderRadius="3px"
        bgcolor="#089B9B"
        border="4px solid #b1e6e6"
      />
      : null}
      <Typography
        variant={variant}
        className={fontSizeCls}
        style={{
          ...(!contentSection ? {margin: '0 0.4em'} : {}),
          padding: 0,
          textTransform: 'uppercase',
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

function SectionSubtitle({ children, ...props }) {
  const [, ,fontFamily] = useRTL('',"'Nunito Sans', sans-serif");
  
  const { data } = useCompanyData();
  const { generalSubTitleFontSize, generalSubTitleColor } = data || {};
  const subTitleFontColor = props.color ? props.color : generalSubTitleColor ? generalSubTitleColor : '#000';

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalSubTitleFontSize && textVariant?.[generalSubTitleFontSize] ? textVariant?.[generalSubTitleFontSize] : textVariant?.['18'];
  
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalSubTitleFontSize && textClasses?.[generalSubTitleFontSize] ? textClasses?.[generalSubTitleFontSize] : textClasses?.['18'];

  return (
    <Box
      color={subTitleFontColor}
      {...props}
      style={{fontFamily:'inherit'}}
      >
      <Typography
        variant={variant}
        className={fontSizeCls}
        // color="inherit"
      >
        {children}
      </Typography>
    </Box>
  );
};

function SectionParagraph({ children, ...props }) {
  const [, ,fontFamily] = useRTL('',"'Nunito Sans', sans-serif");
  const { data } = useCompanyData();
  const { generalParagraphFontSize, generalParagraphColor } = data || {};
  const descFontColor = props.color ? props.color : generalParagraphColor ? generalParagraphColor : '';

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalParagraphFontSize && textVariant?.[generalParagraphFontSize] ? textVariant?.[generalParagraphFontSize] : textVariant?.['16'];
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalParagraphFontSize && textClasses?.[generalParagraphFontSize] ? textClasses?.[generalParagraphFontSize] : textClasses?.['16'];

  return (
    <Box
      color={descFontColor}
      {...props}
      >
      <Typography 
        variant={variant}
        className={fontSizeCls}
        style={{fontFamily:'inherit'}}
        dangerouslySetInnerHTML={props.description}
      />
      </Box>
  );
};

export {
  SectionTitle,
  SectionSubtitle,
  SectionParagraph
}

// export default SectionTitle;
